import { render, staticRenderFns } from "./WorkspaceImportModal.vue?vue&type=template&id=37bdd639&lang=html&"
import script from "./WorkspaceImportModal.vue?vue&type=script&lang=js&"
export * from "./WorkspaceImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports